import React from "react";
import { motion } from "framer-motion";
import logo from "../../assets/logo_sumaqtai.jpg";

const s = (v) => (typeof v === "string" ? v.trim() : "");

function mostrarInformacion(categoria_usuario, nivel, grade, especialidad) {
  const rol = s(categoria_usuario).toLowerCase();
  const niv = s(nivel).toLowerCase();

  if (rol === "docente") {
    const esp = s(especialidad);
    return esp ? `Docente ${nivel} — ${esp}` : `Docente ${nivel}`;
  }

  if (rol === "alumno") {
    let gradoAjustado = Number(grade) || 0;
    if (niv === "primaria") gradoAjustado = (Number(grade) || 0) - 2;
    else if (niv === "secundaria") gradoAjustado = (Number(grade) || 0) - 8;
    const g = gradoAjustado > 0 ? `${gradoAjustado}°` : "—";
    return `${nivel} ${g}`;
  }

  return s(categoria_usuario) || "—";
}

export default function HeaderCustomized({
  brandName = "SUMAQTAI",
  logoUrl = logo,
  username,
  colegio_usuario,
  categoria_usuario,
  nivel_estudiante,
  grade_estudiante,
  especialidad_usuario,
  zoneinfo,
}) {
  const informacionPerfil = mostrarInformacion(
    categoria_usuario,
    nivel_estudiante,
    grade_estudiante,
    especialidad_usuario
  );

  const showBrand = Boolean(s(brandName));
  const [imgError, setImgError] = React.useState(false);

  const fadeUp = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.35, ease: "easeOut" },
  };

  return (
    <header
      className="
        w-full text-white
        bg-gradient-to-r from-cyan-600 to-indigo-600 dark:from-cyan-700 dark:to-indigo-700
        shadow-lg
        pr-8
      "
      role="banner"
      aria-label="Encabezado SumaqtAI"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-3">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          
          {/* Sección Izquierda: Logo y Marca */}
          <motion.div 
            {...fadeUp}
            className="flex items-center gap-3 min-w-0 flex-1"
          >
            {/* Logo */}
            <div className="flex-shrink-0">
              <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full ring-2 ring-white/80 shadow-md bg-white/10 backdrop-blur-sm">
                {logoUrl && !imgError ? (
                  <img
                    src={logoUrl}
                    alt={`${brandName} logo`}
                    className="h-full w-full object-cover"
                    loading="lazy"
                    decoding="async"
                    onError={() => setImgError(true)}
                  />
                ) : (
                  <div className="flex h-full w-full items-center justify-center bg-white/10 text-sm font-bold tracking-wider">
                    <span className="uppercase">AI</span>
                  </div>
                )}
              </div>
            </div>

            {/* Información de la marca */}
            {showBrand && (
              <div className="min-w-0 flex-1">
                <div className="flex flex-col sm:flex-row sm:items-baseline sm:gap-2 min-w-0">
                  <span className="truncate text-lg font-bold leading-tight tracking-wide text-white">
                    {brandName}
                  </span>
                  <span className="text-sm opacity-90 hidden sm:block">•</span>
                  <span className="text-sm opacity-90 truncate">
                    Lecturas que florecen
                  </span>
                </div>
                <div className="flex flex-wrap items-center gap-x-2 text-xs opacity-90 mt-1">
                  <span className="font-semibold">
                    Impulsado por UGEL {s(zoneinfo) || "—"}
                  </span>
                </div>
              </div>
            )}
          </motion.div>

          {/* Sección Derecha: Información del usuario - AHORA CON MARGEN DERECHO */}
          <motion.div
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.08 }}
            className="
              min-w-0 flex-1 sm:flex-none
              flex flex-col items-start sm:items-end
              text-left sm:text-right
              bg-white/5 rounded-lg px-3 py-2 sm:px-4 sm:py-2
              backdrop-blur-sm border border-white/10
              mr-16 sm:mr-0  /* ← NUEVO: Margen derecho para móviles */
            "
            style={{ 
              maxWidth: 'calc(100% - 80px)' /* ← Aseguramos que no llegue al borde */
            }}
          >
            {/* Nombre de usuario y categoría */}
            <div className="flex items-center gap-2 min-w-0 w-full justify-start sm:justify-end">
              <span className="truncate text-sm font-semibold leading-tight text-white">
                {s(username) || "Usuario"}
              </span>
              {s(categoria_usuario) && (
                <span className="shrink-0 rounded-full bg-white/20 px-2 py-1 text-[10px] font-semibold uppercase tracking-wide border border-white/30">
                  {categoria_usuario}
                </span>
              )}
            </div>

            {/* Información adicional del usuario */}
            <div className="min-w-0 text-xs opacity-90 mt-1 w-full">
              <div className="truncate">
                {s(colegio_usuario) && (
                  <span className="font-medium">
                    II.EE {colegio_usuario}
                  </span>
                )}
                
              </div>
              <div className="flex flex-wrap items-center gap-x-2 text-xs opacity-90 mt-1">
                  {informacionPerfil && (
                  <span className={s(colegio_usuario) ? "ml-1" : ""}>
                    {s(colegio_usuario) ? "—" : ""} {informacionPerfil}
                  </span>
                )}
                </div>
            </div>
          </motion.div>

        </div>
      </div>
    </header>
  );
}